import { SetsConfigService } from 'src/services/SetsConfigService';

export const createSetsConfig = async (
    {
        accessToken,
        productKey,
        productName,
        modifiedBy,
        signal,
    }: App.SetsConfigs.CreateMutationVariables,
): Promise<Models.IngestConfigApi.SetsConfigs.ProductSetsConfig> => SetsConfigService.createSetsConfig(
    accessToken,
    productKey,
    productName,
    modifiedBy,
    signal,
);
